/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API48217Req {
  
  /** 任务id */
  taskId?: number;
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  taskStatus?: number;
  /** 任务转交人用户id */
  taskTransferId?: string;
  /** 任务反馈内容 */
  feedback?: string;
};



export interface API48217Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 48217 处理任务/任务反馈

export interface IUsePostAPI48217Return {
  /** 处理任务/任务反馈: 接口请求状态 */
  isAPI48217Loading: boolean;
  /** 处理任务/任务反馈: 接口请求返回数据 */
  dataAPI48217: API48217Res;
  /**  处理任务/任务反馈: 接口数据请求方法 */
  fetchAPI48217Data:  (inputs: API48217Req, config?: YWRequestConfig) => Promise<API48217Res>;
  /** 处理任务/任务反馈: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI48217 = ():IUsePostAPI48217Return => {
  let isMount = true;
  const [isAPI48217Loading, setIsAPI48217Loading] = useState(false);
  const [dataAPI48217, setDataAPI48217] = useState<API48217Res>({} as API48217Res);
  const requestUrl = `${basePath}/team-work/workTask/dealWorkTask`;

  const fetchAPI48217Data = async (inputs: API48217Req, config?: YWRequestConfig): Promise<API48217Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48217Req>) || {}) as API48217Req;
    
  
    if ( isMount ) {
      setIsAPI48217Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API48217Res>(`${basePath}/team-work/workTask/dealWorkTask`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI48217(res || {} as API48217Res);
        setIsAPI48217Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48217Loading(false);
      }
      return false as unknown as API48217Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48217Loading,
    dataAPI48217,
    fetchAPI48217Data,
    requestUrl,
  }
}

